import * as THREE from 'three'
import React, { useRef, Suspense } from 'react'
import { useFrame } from 'react-three-fiber'
import TextureAnimation from './TextureAnimation'
import calcAngleAroundYaxis from './utility/calcAngleAroundYaxis'

const Billboard = (props) => {
	const texture = useRef(null)
	const scale = props.size

	useFrame((state, delta) => {
		if (texture.current === null) {
			return
		}

		const viewDirection = state.camera.position.clone().sub(new THREE.Vector3(props.position[0], props.position[1], props.position[2]))
		const view = new THREE.Vector3(viewDirection.x, 0, viewDirection.z)
		const front = new THREE.Vector3(props.direction[0], 0, props.direction[2])
		const angel = calcAngleAroundYaxis(front, view, props.isClockwise)
		const unitAngle = angel / (2 * Math.PI)
		const frame = Math.round(props.frameNum * unitAngle)

		texture.current.setCurrentFrame((frame < props.frameNum) ? frame : 0)

	})

	return (
		<mesh position={props.position} scale={scale}>
			<Suspense fallback={null}>
				<sprite position={[0, 0.5, 0]}>
					<TextureAnimation
						ref={texture}
						{...props}
					/>
				</sprite>
			</Suspense>
		</mesh>
	)
}

export default Billboard